import { Shape } from "./RampCanvasV2";

export const updateAtId = (shapes: Shape[], newShape: Shape): Shape[] => {
  return shapes.map((s) => (s.id === newShape.id ? newShape : s));
};
